
export default {
  getUsuario: state => state.Usuario,
  getPerfil: state => state.Usuario.perfil,
  getEmbarcador: state => state.Embarcador,
  getColaboradores: state => state.Embarcador.colaboradores,
  getParceiros: state => state.Embarcador.parceiros,
  getEstados: state => state.Estados,
  getEstadosCivil: state => state.EstadosCivil,
  getEstadoBySigla: state => (sigla) => state.Estados.filter(estado => estado.sigla === sigla),
  getCidades: state => state.Cidades,
  getCidadesBahia: state => state.Cidades[29],
  getCnaes: state => state.Cnaes,
  getSegmentos: state => state.Segmentos,
  getPortes: state => state.Portes,
  getEmbalagens: state => state.Embalagens,
  getBancos: state => state.Bancos.filter(banco => banco.ativo === true).sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0)),
  getPerfis: state => state.Perfis,
  getTiposVeiculo: state => state.TiposVeiculo,
  getTiposCarroceria: state => state.TiposCarroceria,
  getFreteStatus: state => state.FreteStatus,
  getFreteStatusById: state => (id) => state.Estados.filter(status => status.id === id),
  getTotalFretesRascunho: state => state.TotalFretesRascunho,
  getTiposPessoa: state => state.TiposPessoa,
  getTiposNegocioCliente: state => state.TiposNegocioCliente,
  getLoginExpired: state => state.Auth.login.expired
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js